module.exports = __webpack_public_path__ + "img/27 trabajo.3068920a.jpg";